<section
  class="landing-a__section landing-a__compare-section"
  appLandingReveal="landing-a__compare-section--visible"
>
  <div class="landing-a__container">
    <div class="landing-a__section-heading">
      <span class="landing-a__section-kicker">{{ 'landing.landing_1.comparison.kicker' | translate }}</span>
      <h2>{{ 'landing.landing_1.comparison.title' | translate }}</h2>
      <p>{{ 'landing.landing_1.comparison.subtitle' | translate }}</p>
    </div>

    <div class="landing-a__compare-wrapper">
      <table class="landing-a__compare">
        <thead>
          <tr>
            <th scope="col">
              <span class="landing-a__visually-hidden">{{ 'landing.landing_1.comparison.criteria' | translate }}</span>
            </th>
            <th scope="col">{{ 'landing.landing_1.comparison.manual' | translate }}</th>
            <th scope="col" class="landing-a__compare-highlight">Treeslo</th>
          </tr>
        </thead>
        <tbody>
          @for (row of compareRows; track row) {
            <tr>
              <th scope="row">{{ 'landing.landing_1.comparison.rows.' + row + '.label' | translate }}</th>
              <td>
                <i-tabler name="x" class="landing-a__compare-x"></i-tabler>
                {{ 'landing.landing_1.comparison.rows.' + row + '.manual' | translate }}
              </td>
              <td class="landing-a__compare-highlight">
                <i-tabler name="check" class="landing-a__compare-check"></i-tabler>
                {{ 'landing.landing_1.comparison.rows.' + row + '.treeslo' | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</section>
